import { createContext, type ReactNode, useContext } from 'react';
import { Temporal } from 'temporal-polyfill';

export type Clock = {
  readonly timeZone: () => string;
  readonly today: () => Temporal.PlainDate;
};

const viewerTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const realClock: Clock = {
  timeZone: viewerTimeZone,
  today: () => Temporal.Now.plainDateISO(viewerTimeZone()),
};

const ClockContext = createContext<Clock | undefined>(undefined);

export function ClockProvider({
  clock,
  children,
}: {
  clock: Clock;
  children: ReactNode;
}) {
  return <ClockContext value={clock}>{children}</ClockContext>;
}

export function useClock(): Clock {
  const clock = useContext(ClockContext);
  if (!clock) {
    throw new Error('useClock must be used within a ClockProvider');
  }
  return clock;
}
